
























import { CreateElement, RenderContext } from "vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class UDropdownItem extends Vue {
  // Props

  @Prop({ default: null })
  public value!: any;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: false })
  public custom!: boolean;

  @Prop({ default: true })
  public focusable!: boolean;

  @Prop({ default: false })
  public paddingless!: boolean;

  @Prop({ default: false })
  public hasLink!: boolean;

  @Prop({ default: "" })
  public ariaRole!: string;

  @Prop({ default: undefined })
  public tooltip?: {
    label: string;
    active?: boolean;
    multilined?: boolean;
    type?: string;
  };

  // Computed

  public get component() {
    return {
      functional: true,
      render: (h: CreateElement, { children }: RenderContext) => {
        if (!this.$_.isEmpty(this.tooltip))
          return h(
            "b-tooltip",
            {
              props: { multilined: true, ...this.tooltip },
              class: "is-block"
            },
            children
          );
        return children;
      }
    };
  }

  public get anchorClasses() {
    return {
      "is-disabled": (this.$parent as any).disabled || this.disabled,
      "is-paddingless": this.paddingless,
      "is-active": this.isActive
    };
  }

  public get itemClasses() {
    return {
      "dropdown-item": !this.hasLink,
      "is-disabled": this.disabled,
      "is-paddingless": this.paddingless,
      "is-active": this.isActive,
      "has-link": this.hasLink
    };
  }

  public get ariaRoleItem() {
    return this.ariaRole === "menuitem" || this.ariaRole === "listitem"
      ? this.ariaRole
      : null;
  }

  public get isClickable() {
    return !(this.$parent as any).disabled && !this.disabled && !this.custom;
  }

  public get isActive() {
    if ((this.$parent as any).selected === null) return false;
    if ((this.$parent as any).multiple)
      return (this.$parent as any).selected.indexOf(this.value) >= 0;
    return this.value === (this.$parent as any).selected;
  }

  public get isFocusable() {
    return this.hasLink ? false : this.focusable;
  }

  // Methods

  public selectItem() {
    if (!this.isClickable) return;
    (this.$parent as any).selectItem(this.value);
    this.$emit("click");
  }

  // Life-cycle methods

  public created() {
    if (!this.$parent.$data._isDropdown) {
      this.$destroy();
      throw new Error("You should wrap uDropdownItem on a bDropdown");
    }
  }
}
